// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3mHh2","buttons":"PendingPaymentAlert_buttons__1MlnD"};